import { Container, Row, Col, Tab, Nav, Card } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import dashImg1 from "../assets/img/als/servicos/Filtro.png";
import dashImg2 from "../assets/img/als/servicos/EE.png";
import dashImg3 from "../assets/img/als/servicos/LT.png";
import dashImg4 from "../assets/img/als/servicos/MD.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';

export const Services = () => {

  const services = [
    {
      title: "Projetos Mecânicos e Elétricos",
      description: "Concepção, Projeto 3D, Projeto 2D para Fabricação, Lista de Material. Foco em Desenvolvimento de Novos Equipamentos.",
      imgUrl: dashImg1,
    },
    {
      title: "Eficiência Energética",
      description: "Projeto de redução de custos com energia elétrica e análise da qualidade de energia. Foco em Redução de custos.",
      imgUrl: dashImg2,
    },
    {
      title: "Laudos Técnicos",
      description: "Laudo SPDA, Laudo de Aterramento de Máquina, Laudos NR10, Nr12 e NR13. Foco em regularização normativa.",
      imgUrl: dashImg3,
    },
    {
      title: "Manufatura Digital",
      description: "Adição de sensores para acompanhamento remoto de produção. Foco em Elevação de Produtividade.",
      imgUrl: dashImg4,
    },
  ];

  return (
    <section className="project" id="portfolio">
      <Container>
        <Row>
          <Col size={12}>
            <h2>Serviços</h2>
            <Row >
              {
                services.map((project, index) => {
                  return (
                    <ProjectCard
                      key={index}
                      {...project}
                      />
                   
                  )
                })
              }
            </Row>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}
